// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');
const trim = require('lodash/string/trim');

// @ components
const { BrokerMiFIDBehavior } = require('mifid/components/brokerMiFIDBehavior/brokerMiFIDBehavior');

// @ constants
const {
  BROKER_CONVENIENCE_MIFID_CRYPTO_BUY,
  BROKER_CONVENIENCE_MIFID_CRYPTO,
  BROKER_CONVENIENCE_MIFID_TEST_CRYPTO_ID,
  BROKER_CONVENIENCE_MIFID_TEST_CRYPTO_INT_ID,
  BROKER_MIFID_VERSION_2,
  MYPROFILE_BROKER_CRYPTO_URL,
} = require('constants/index');

const GO_TO_MY_WALLET_URL = '/myprofile/broker/general';
const DEFAULT_CRYPTO_ISIN = 'BTCEUR';
const DEFAULT_CRYPTO_ISO = 'CRF';

class BrokerCryptoTestView extends React.Component {
  getCryptoID() {
    const { location } = this.props;
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get('cryptoID');
  };

  render() {
    const mifidOptions = {
      productType: BROKER_CONVENIENCE_MIFID_CRYPTO,
      operationType: BROKER_CONVENIENCE_MIFID_CRYPTO_BUY,
    };
    const isin = DEFAULT_CRYPTO_ISIN;
    const iso = DEFAULT_CRYPTO_ISO;
    const productUrl = GO_TO_MY_WALLET_URL;
    const cryptoID = this.getCryptoID();
    const continuationUrl = !!cryptoID
      ? `${MYPROFILE_BROKER_CRYPTO_URL}/buy/${cryptoID}`
      : MYPROFILE_BROKER_CRYPTO_URL;
    const isComplex = this.props.productFile.get('isComplex');
    const productId = isComplex
      ? BROKER_CONVENIENCE_MIFID_TEST_CRYPTO_INT_ID
      : BROKER_CONVENIENCE_MIFID_TEST_CRYPTO_ID;
    return (
      <BrokerMiFIDBehavior
        mifidVersion={BROKER_MIFID_VERSION_2}
        mifidOptions={mifidOptions}
        productUrl={productUrl}
        continuationUrl={continuationUrl}
        productIsinId={isin}
        productMarketId={iso}
        productName={isin}
        productMifidId={productId}
      >
        <div />
      </BrokerMiFIDBehavior>
    );
  }
}

module.exports.BrokerCryptoTestView = connect(
  state => ({ productFile: state.brokerProductFile }),
  {}
)(withRouter(BrokerCryptoTestView));
